import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { FaqAll } from "../components/faq/FaqAll";
import { IFaqsData } from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";
import { fetchEnglishFaqs, fetchNepaliFaqs } from "../api/FaqApi";
import { dynamicFailed } from "../hooks/custom/useToast";

const FaqPage = () => {
  const { setLoading } = useLoader();
  const [englishFaqs, setEnglishFaqs] = useState<IFaqsData[]>([]);
  const [nepaliFaqs, setNepaliFaqs] = useState<IFaqsData[]>([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  
  useEffect(() => {
    setLoading(true);
    Promise.all([fetchEnglishFaqs(), fetchNepaliFaqs()])
      .then(([englishFaqsData, nepaliFaqsData]) => {
        setEnglishFaqs(englishFaqsData);
        setNepaliFaqs(nepaliFaqsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  return (
    <>
      <Banner title="Faq" />
      <FaqAll englishFaqs={englishFaqs} nepaliFaqs={nepaliFaqs} />
    </>
  );
};

export default FaqPage;
